import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=581dff6c&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=581dff6c&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581dff6c')) {
      api.createRecord('581dff6c', component.options)
    } else {
      api.reload('581dff6c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=581dff6c&", function () {
      api.rerender('581dff6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/supervision/costentry/components/edit.vue"
export default component.exports